import { render, staticRenderFns } from "./SPIFAboutTheData.vue?vue&type=template&id=0d8915e1"
import script from "./SPIFAboutTheData.vue?vue&type=script&lang=js"
export * from "./SPIFAboutTheData.vue?vue&type=script&lang=js"
import style0 from "./SPIFAboutTheData.vue?vue&type=style&index=0&id=0d8915e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports